import { useContext, useMemo, useState } from "react";

import { ThemeContext } from "./context";
import {
  SearchBar,
  SwitchInput,
  Grid,
  TagPane,
  NavBar,
  Logo,
} from "./components";

// [+-] dc: use preinitialized query handling context object
// @todo: ideally it should work as separate lib exposing certain methods
// import { DUMMY_DATA, FIELDS_TO_SEARCH } from "./constants";
import CTX from "./constants/init";



function App() {
  const [query, setQuery] = useState("");
  const [queryGroups, setQueryGroups] = useState([]);
  const [tags, setTags] = useState([]);

  const { themeName, isDarkMode, toggleTheme } = useContext(ThemeContext);

  const removeTag = (index) =>
    setTags((t) => [...t.slice(0, index), ...t.slice(index + 1)]);

  const addTag = (tag) => setTags((t) => [...t, tag]);

  // [+-] dc
  const onInput = (q) => {
	// prevent useless work
	if (query == q){ return; }

	setQuery(q);
    setQueryGroups(CTX.onInput(q));
  };

  // [+-] dc
  const onEnter = (key) => {
    if (key === "Enter") {
		CTX.onEnter(tags, query).forEach(CTX.openLink);
	}
  };

  const filterGroups = useMemo(() =>
	queryGroups.filter(
		(qGroup) => !tags.some((tag) => tag.name === qGroup.tag)
	),
	[queryGroups, tags]
  );

  return (
    <div className={`app ${themeName}`}>
      <NavBar>
        <SwitchInput checked={isDarkMode} onChange={toggleTheme} />
      </NavBar>
      <header className="app-content uk-container uk-container-xsmall">
        <div className="uk-margin-xlarge-top uk-flex uk-flex-column uk-flex-middle">
          <Logo />
          <TagPane tags={tags} removeTag={removeTag}>
            <SearchBar
              value={query}
              onKeyPress={onEnter}
              onInput={onInput}
            />
          </TagPane>

          <Grid data={filterGroups} onClickItem={addTag} />
        </div>
      </header>
    </div>
  );
}

export default App;
